module.exports = __webpack_public_path__ + "img/pauli-z-root-14.93d6369f.svg";